export default "__VITE_ASSET__CghO$wtB__"